import { Alert, Button, Image, Space, Spin } from "antd";
import exam from "../assets/exams.png";
import {motion} from "framer-motion";
import { useTranslation } from "react-i18next";
import { RefreshCcw } from "lucide-react";

interface Props {
  isFetching: boolean;
  isError: boolean;
  isLoading: boolean;
  refetch: any;
}

export const LoadingLayout = ({isError, isLoading, refetch, isFetching}: Props) => {


  const {t} = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
     <Space direction="vertical" size={"large"} style={{textAlign: 'center'}}>
      <Image src={exam} preview={false} />
      {isError && (
        <div style={{display: 'flex', flexDirection: 'column', gap: "16px", alignItems: 'center'}}>
          <Alert message={t("messages.error.getUser")} type="error" showIcon />
          <Button type="primary" icon={<RefreshCcw />} style={{width: "150px"}} onClick={() => refetch()}>
            {t("loadAgain")}
          </Button>
        </div>
      )}
      {(isLoading || isFetching) && <Spin />}
     </Space>
    </motion.div>
  );
};
